import '@ant-design/v5-patch-for-react-19';
import * as Sentry from '@sentry/react';
import { logger } from '@ui/utils/logger';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './instrument';
import './polyfills/crypto';

const rootEl = document.getElementById('root');

if (rootEl) {
    const root = ReactDOM.createRoot(rootEl, {
        // Callback called when an error is thrown and not caught by an ErrorBoundary.
        onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
            logger.warn('Uncaught error', { error, componentStack: errorInfo.componentStack });
        }),
        // Callback called when React catches an error in an ErrorBoundary.
        onCaughtError: Sentry.reactErrorHandler(),
        // Callback called when React automatically recovers from errors.
        onRecoverableError: Sentry.reactErrorHandler(),
    });

    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}
